import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';

import { CardMedia, CircularProgress, Box } from '@mui/material';

import noProperty from '../../assets/images/no-image.png';

const ImageComponent = memo(({ imageUrl, spinnerSize, fallbackImg, imgStyles }) => {
  const [loading, setLoading] = useState(false);
  return (
    <>
      {!loading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            justifyContent:'center'
          }}
        >
          <CircularProgress color="info" size={spinnerSize} />
        </Box>
      )}
      <CardMedia
        sx={{
          ...imgStyles,
          display: loading ? 'block' : 'none',
        }}
        onLoad={() => {
          setLoading(true);
        }}
        src={imageUrl}
        onError={(e) => {
          setLoading(true);
          e.currentTarget.onerror = null;
          e.currentTarget.src = fallbackImg;
        }}
        component="img"
      />
    </>
  );
});

ImageComponent.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  spinnerSize: PropTypes.number,
  fallbackImg: PropTypes.any,
  imgStyels: PropTypes.any,
};

ImageComponent.defaultProps = {
  spinnerSize: 40,
  fallbackImg: noProperty,
  imgStyles: {},
};

export default ImageComponent;
